import React, { useState } from 'react';
import './index.scss';
import { Dropdown } from 'antd';
import CompleteIssue from '../CompleteIssue';
import OnHoldIssue from '../OnHoldIssue';
import TransferIssue from '../TransferIssue';
import DiscardIssue from '../DiscardIssue';
import CreateIssue from '../CreateIssue';

const IssueCommand = (props: {
  vehicleName: string;
  ticketOperationPermission: any;
  disabled: any;
  vehicleSupplier: string;
}) => {
  const { vehicleName, ticketOperationPermission, disabled, vehicleSupplier } =
    props;
  const [dropdownBtnsShow, setDropdownBtnsShow] = useState(false);

  const dropdownContent = (
    <div className="issue-command-panel" onClick={(e) => e.stopPropagation()}>
      <div className="command-row">
        <CompleteIssue
          vehicleName={vehicleName}
          disabled={!ticketOperationPermission || !!disabled}
          closeDropdown={() => setDropdownBtnsShow(false)}
          vehicleSupplier={vehicleSupplier}
        />
        <DiscardIssue
          vehicleName={vehicleName}
          disabled={!ticketOperationPermission || !!disabled}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
      <div className="command-row">
        <TransferIssue
          vehicleName={vehicleName}
          disabled={!ticketOperationPermission || !!disabled}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <OnHoldIssue
          vehicleName={vehicleName}
          disabled={!ticketOperationPermission || !!disabled}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
      <div className="command-row">
        <CreateIssue
          vehicleName={vehicleName}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
    </div>
  );

  return (
    <Dropdown
      popupRender={() => dropdownContent}
      trigger={['click']}
      placement="topCenter"
      open={dropdownBtnsShow}
      onOpenChange={() => setDropdownBtnsShow(!dropdownBtnsShow)}
    >
      <div className="issue-command-container">
        <i></i>
        <div className="issue-command">工单指令</div>
      </div>
    </Dropdown>
  );
};

export default IssueCommand;
